import { ThemeProvider } from 'styled-components';
import useSite from '~/client/hooks/useSite';
import getTheme from '~/shared/utils/theme/getTheme';
import TailwindThemeProvider from '../TailwindThemeProvider';

const THEMES_MAP: SiteRecord<Theme> = {
  livecasino: getTheme('livecasinoLight'),
  sportsbet: getTheme('sportsbetLight'),
  bitcasino: getTheme('bitcasinoLight'),
  sportsbetmx: getTheme('sportsbetLight'),
  empire: getTheme('empireLight'),
};

const LightThemeProvider: FC = ({ children }) => {
  const { site } = useSite();
  const theme = THEMES_MAP[site];
  return (
    <ThemeProvider theme={theme}>
      <TailwindThemeProvider colorScheme="light">
        {children}
      </TailwindThemeProvider>
    </ThemeProvider>
  );
};

export default LightThemeProvider;
